import React, { Component } from 'react';
import styles from './_userLayout.module.scss';

class UserLayout extends Component {
  state = {
    isSidebarShow: false,
  };

  componentDidMount() {
    this.props.requestGoalList();
  }

  handleSidebar = () => {
    const { isSidebarShow } = this.state;
    if (isSidebarShow) {
      document.body.classList.remove('bodyMobileOverflowHidden');
    } else {
      document.body.classList.add('bodyMobileOverflowHidden');
    }
    this.setState({ isSidebarShow: !isSidebarShow });
  };

  closeSidebar = () => {
    document.body.classList.remove('bodyMobileOverflowHidden');
    this.setState({ isSidebarShow: false });
  };

  render() {
    const { children } = this.props;

    return <div className={styles['user-layout-page-container']}>{children}</div>;
  }
}

export default UserLayout;
